
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.card {
  height: 100%;
  place-self: stretch;
  padding: 0.5rem;
}@media (min-width: 768px) {.card {
    padding: 1rem;
  }
}.card {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  box-shadow:0 4px 14px rgba(0, 0, 0, 0.1);
}

.card .img-wrapper {
  position: relative;
  width: 100%;
}

.card .video-wrapper {
  height: 100%;
  max-height: 327px;
  width: 100%;
}

.card .video-wrapper iframe {
  height: 100%;
  width: 100%;
  border-radius: 0.7rem;
}

.card img {
  max-height: 327px;
  width: 100%;
  max-width: 100%;
  border-radius: 0.5rem;
  object-fit: cover;
}

.card-body {
  width: 100%;
}

::slotted(ul) {
  width: 100%;
  list-style-type: none !important;
  padding: 0px;
}

.card-body li img{
  width:20px;
  height:20px;
}

.outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

.outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4);
}

.outline-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.outline-bg-green {
  background-color: var(--green-guarantee-lighten-4);
}

.outline-bg-white {
  background-color: var(--neutral-white);
}

.outline-bg-transparent {
  background-color: var(--neutral-transparent);
}
`;